const bannerConstants = {
  home: {
    width: 428,
    height: 642,
  },
};

export default bannerConstants;
